
window.addEventListener("load", function () {
    const $item = $('#vxphl-ld-25-a-navigation .list-navs > li').eq(2);
    console.log($item);
    $item.on('click', function (e) {
        e.preventDefault();
       
        $('#libraryMainsite-t-float_left .list-btns a').last().trigger('click');
    });
    if ($('body').data('device-type') === 'desktop') {
        let audio = null;
        $('.MS__sprite-btn-music').on('click', function (e) {
            e.preventDefault();

            const $btn = $(this);
            const audioSrc = $('#MS__wrapper').attr('data-audio');
            if (!audioSrc) return;

            // Khởi tạo audio nếu chưa có
            if (!audio) {
                audio = document.createElement('audio');
                audio.id = 'dynamic-audio';
                audio.src = audioSrc;
                document.body.appendChild(audio);

                // Gán onended đúng 1 lần duy nhất
                audio.onended = function () {
                    $btn.removeClass('active');
                };
            }

            // So sánh src bằng getAttribute (tránh reload liên tục)
            const currentSrc = audio.getAttribute('src');
            if (currentSrc !== audioSrc) {
                audio.pause();
                audio.src = audioSrc;
                audio.load();
            }

            // Toggle phát / tạm dừng
            if (audio.paused || audio.ended) {
                audio.play().then(() => {
                    $btn.addClass('active');
                }).catch((err) => {
                    console.warn('Audio play failed:', err);
                });
            } else {
                audio.pause();
                $btn.removeClass('active');
            }
        });

        // $(window).one('click keydown', function (e) {
        //     if ($('body').data('device-type') === 'desktop') {
        //         if (!$(e.target).closest('.btn-music').length) {
        //             $('#vxphl-ld-25-a-navigation .btn-music').trigger('click');
        //         }
        //     }
        //     // Nếu click không phải từ trong .btn-music thì mới trigger

        // });
    }



});

